module.exports = __webpack_public_path__ + "img/remark_04.84f8c559.svg";